import HorizonEnsemble2 from "../images/HorizonEnsemble2.jpg";
import CallForScoresArtists from "../images/CallForScoresArtists.jpg";

export default function CallForScores() {
  return (
    <div>
    <main className="page-header">
        <h2>Horizon Ensemble 2024 Call for Scores!</h2>
    </main>
    <div style={{backgroundColor: "white"}}>
      <img className="ensemble-picture" src={HorizonEnsemble2}/>
    </div>
    <p style={{fontSize: "21px", margin: "10vh"}}>
       <h3 style={{fontWeight: "bolder"}}>Our 2024 Call For Scores has now ended!</h3>
       The Horizon Ensemble is happy to announce our very first Call for Scores winners!
       <br/> Thank you to everyone who submitted a score. It was an absolute delight to look at each composition. 
       <br/> We were incredibly happy with the amount of scores we received and their quality and creativity... 
       <br/> but in the end, we had to pick 4 scores total. You all made it an incredibly hard decision!
    </p>
    <body className='outreach'>
        <div style={{margin: '10vh'}}>
          <h3><strong>An orchestral piece...</strong></h3>
          <p style={{fontSize: "21px"}}>Our spring concert, <strong>Massachusetts Voices,</strong> on April 6th featured our winning orchestral piece alongside music by Ben Nacar, Amy Beach, and Leonard Bernstein, performed by the Horizon Ensemble in Boston, Massachusetts.
          <br/> Our winning orchestral submission was <strong>John Rotar's "Coonarr,"</strong> with an honorable mention to <strong>Chun-Wai Wong's "Lament from the Forest II".</strong>
</p>
        </div>
        <div style={{margin: '10vh'}}>
          <h3><strong>...and some chamber music!</strong></h3>
          <p style={{fontSize: "21px"}}>As part of our mission to support young composers, the Horizon Ensemble has selected <strong>three chamber pieces</strong> for a professional-level studio recording to be made in late springtime, conducted by our music director Julian Gau. 
          <br/> The three chamber pieces chosen are 
          <ul style={{margin: '10vh', textAlign: "left"}}>
            <li><strong>Theo Chandler's "Trailing Wings"</strong></li> 
            <li><strong>Arjan Singh Dogra's "Khulasa"</strong></li> 
            <li><strong>Daniel Sabzghabaei's "outside(inside)out"</strong></li></ul>
</p>
        </div>
    </body>
    <body className="outreach" style={{backgroundColor: "#C8E6F7"}}>
      <div style={{margin: '10vh', textAlign: "left"}}>
        <h3><strong>The submission requirements for the 2024 Call For Scores were as follows:</strong></h3>
        <p style={{fontSize: "21px"}}>
          <ul>
            <li><u>Full scores and parts</u> without names       
         <br/><i>(the evaluation process is name-blind)</i></li>
         <li>Composer info: bio, contact info, socials (optional) 
          <br/><i>(this is for after the piece is chosen)</i></li>
          <li>Performance notes if needed</li>
          <li>Program notes</li>
          <li>Audio (live recording or digital realization)</li>
          </ul>
          Submissions which lack any of these elements, which are outside of the above length requirements, or which have scores or parts with names on them were not considered.  
</p>
      </div>
      <img src={CallForScoresArtists} className='ensemble-picture' style={{margin: "15vh"}}/>
      </body>
      <body className="outreach" style={{flexDirection: "column"}}>
        <p style={{fontSize: "21px", textAlign: "left"}}>
          Applications were open from <strong>November 4, 2024</strong> to <strong>December 9, 2024.</strong>
          <br/>If you have any questions, please contact us at horizonensembleboston@gmail.com.
          <br/>Thank you for all who considered becoming one of Horizon Ensemble’s composer friends! We'll see you at our next Call For Scores.</p>
      </body>
  </div>
  );
}
